import { useQuery, UseQueryResult } from 'react-query';
import { OrgHierarchy } from '@weave/schema-gen-ts/dist/apis/api/identity/v1/api.pb';
import { getOrgHierarchy } from './api';

export const IdentitySearchQueryKeys = {
  GET_ORG_HIERARCHY: 'identity-search-org-hierarchy',
  GET_ORG: 'identity-search-org',
};

export const useOrgHierarchy = (orgId: string): UseQueryResult<OrgHierarchy> =>
  useQuery({
    queryKey: [IdentitySearchQueryKeys.GET_ORG_HIERARCHY, orgId],
    queryFn: () => getOrgHierarchy(orgId),
    enabled: !!orgId,
  });
